import { RouterModule, Routes } from '@angular/router';
import { QuicklinkStrategy } from 'ngx-quicklink';

import { AuthGuard } from './security/auth.guard';
import { PermissionConst } from './security/generated/Permission';
import { ViewPrivacyPolicyFooterComponent } from '../admin/footer/view-privacy-policy-footer/view-privacy-policy-footer.component';
import { ViewTermsConditionsFooterComponent } from '../admin/footer/view-terms-conditions-footer/view-terms-conditions-footer.component';

// This is the root of our navigation menu route definitions
const routes: Routes = [
	{
		path: ''
        , pathMatch: 'full'
        , loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent) 
	}
    , {
		path: 'dashboard'
        , canActivate: [ AuthGuard ]
        , loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent) 
	}
    , {
		path: 'login'
        , loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent) 
	}
    , {
		path: 'create-account'
        , loadComponent: () => import('./pages/create-account/create-account.component').then(m => m.CreateAccountComponent) 
	}
    , {
		path: 'opt-in-screenshots'
        , loadComponent: () => import('./pages/opt-in-screenshots/opt-in-screenshots.component').then(m => m.OptInScreenshotsComponent) 
	}
    , {
		path: 'admin/users/list'
        , loadComponent: () => import('../admin/users/user-list/users.component').then(m => m.UsersComponent) 
	}
    , {
		path: 'company/edit'
        , loadComponent: () => import('../admin/company/company.component').then(m => m.CompanyComponent)
	}
    , {
		path: 'company/list'
        , canActivate: [ AuthGuard ]
        , data: { security: PermissionConst.adminFeatures }
        , loadComponent: () => import('../admin/company/all-companies-list/all-companies-list.component').then(m => m.AllCompaniesListComponent)
	}
    , {
		path: 'company/edit/:id'
        , canActivate: [ AuthGuard ]
        , data: { security: PermissionConst.adminFeatures }
        , loadComponent: () => import('../admin/company/company.component').then(m => m.CompanyComponent)
	}
    , {
		path: 'release-notes'
        , canActivate: [ AuthGuard ]
        , loadComponent: () => import('./pages/release-notes/release-notes.component').then(m => m.ReleaseNotesComponent) 
	}
    , {
		path: 'forgot-password'
        , loadComponent: () => import('./pages/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent) 
	}
    , {
		path: 'change-password/:id'
        , loadComponent: () => import('./pages/change-password/change-password.component').then(m => m.ChangePasswordComponent) 
	}
    , {
		path: 'apts'
        , canLoad: [ AuthGuard ]
        , loadChildren: () => import('../appointments/my-appointments.module').then(m => m.MyAppointmentsModule)
	}
    , {
		path: 'all-apts'
        , canLoad: [ AuthGuard ]
        , loadChildren: () => import('../all-appointments/all-appointments.module').then(m => m.AllAppointmentsModule)
	}
    , {
		path: 'realtors'
        , canLoad: [ AuthGuard ]
        , loadChildren: () => import('../realtors/realtors.module').then(m => m.RealtorsModule)
	}
    , {
		path: 'admin'
        , canLoad: [ AuthGuard ]
        , loadChildren: () => import('../admin/admin.module').then(m => m.AdminModule)
	}
    , {
		path: 'help'
        , canActivate: [ AuthGuard ]
        , data: { security: PermissionConst.coreFeatures }
        , loadComponent: () => import('../help/help-files.component').then(m => m.HelpFilesComponent) 
	}
    , {
		path: 'help/:param'
        , canActivate: [ AuthGuard ]
        , data: { security: PermissionConst.coreFeatures }
        , loadComponent: () => import('../help/help-files.component').then(m => m.HelpFilesComponent) 
	}
    , {
		path: 'help/help-video/:id'
        , canActivate: [ AuthGuard ]
        , data: { security: PermissionConst.coreFeatures }
        , loadComponent: () => import('../help/help-videos/help-videos.component').then(m => m.HelpVideosComponent) 
	}
    , {
		path: 'confirm-appointment/:guid'
        , loadComponent: () => import('./pages/confirm-appointment/confirm-appointment.component').then(m => m.ConfirmAppointmentComponent) 
	}
    , {
		path: 'eula'
        , loadComponent: () => import('../admin/footer/view-eula-footer/view-eula-footer.component').then(m => m.ViewEulaFooterComponent) 
	}
    , { 
		path: 'privacy-policy'
		, component: ViewPrivacyPolicyFooterComponent 
	}
	, { 
		path: 'terms-and-conditions'
		, component: ViewTermsConditionsFooterComponent 
	} 
    , {
		path: '**'
        , redirectTo: ''
	}
];

export class CoreRouting {
    static readonly declarations = [	];
	static readonly imports = [
		RouterModule.forRoot(
            routes
            , {
			    scrollPositionRestoration: 'enabled'
                , preloadingStrategy: QuicklinkStrategy
		    }
        )
	];
	static readonly exports = [ RouterModule ];
	static readonly providers = [ AuthGuard ];
}
